import React from 'react';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <main 
      className="relative min-h-[80vh] sm:min-h-screen flex items-center"
      role="banner"
      aria-label="Nirvana Ayurveda - Ancient Wisdom, Modern Wellness"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Serene%20ayurvedic%20wellness%20background%20with%20natural%20herbs%2C%20green%20leaves%2C%20mortar%20and%20pestle%2C%20soft%20natural%20lighting%2C%20peaceful%20spa%20environment%2C%20warm%20earth%20tones%2C%20organic%20textures%2C%20left%20side%20has%20solid%20warm%20beige%20background%20perfect%20for%20text%20overlay%2C%20right%20side%20shows%20beautiful%20ayurvedic%20herbs%20and%20natural%20elements%2C%20professional%20photography%20style%2C%20high%20quality%2C%20minimalist%20composition&width=1920&height=1080&seq=hero1&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/85 sm:via-white/80 to-transparent"></div>
      
      <div className="relative w-full px-4 sm:px-6 py-12 sm:py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              <span className="block">Ancient Wisdom,</span>
              <span className="text-green-600 block">Modern Wellness</span>
            </h1>
            
            <p className="text-base sm:text-lg md:text-xl text-gray-700 mb-6 sm:mb-8 leading-relaxed">
              Discover the healing power of authentic Ayurvedic products. 
              Crafted with pure herbs and traditional wisdom to restore your natural balance and vitality.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-8 sm:mb-12">
              <Link to="/products" className="bg-green-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-green-700 transition-all duration-300 transform hover:scale-105 text-center">
                Shop Products
              </Link>
              <Link to="/about" className="border-2 border-green-600 text-green-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-green-600 hover:text-white transition-all duration-300 text-center">
                Learn More
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="flex items-center space-x-3">
                <div className="w-10 sm:w-12 h-10 sm:h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-leaf-line text-green-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-sm sm:text-base">100% Natural</h3>
                  <p className="text-gray-600 text-xs sm:text-sm">Pure herbal ingredients</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 sm:w-12 h-10 sm:h-12 flex items-center justify-center bg-green-100 rounded-full flex-shrink-0">
                  <i className="ri-shield-check-line text-green-600 text-lg sm:text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 text-sm sm:text-base">Certified Safe</h3>
                  <p className="text-gray-600 text-xs sm:text-sm">Lab tested & approved</p>
                </div>
              </div>
              
              {/* <div className="flex items-center space-x-3">
                <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-full">
                  <i className="ri-truck-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Free Shipping</h3>
                  <p className="text-gray-600 text-sm">On orders over $50</p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}